<div [ngClass]="{ 'title-transition': !isEmbedded }" class="question">
  <h1 class="title" [ngClass]="{ embedded: isEmbedded }" data-e2e="questionText">{{ question?.display?.title }}</h1>
</div>
<div [ngClass]="{ 'answer-widget-transition': !isEmbedded }">
  <kp-answer [question]="question" (answer)="setAnswer($event)"></kp-answer>
</div>
